module.exports = __webpack_public_path__ + "static/media/imperial.0644e50a.png";